export const conjunciones: string[] = [
  // Español
  "y", "e", "ni", "que",           // Copulativas
  "o", "u",                        // Disyuntivas
  "pero", "aunque", "sin embargo", "no obstante", // Adversativas
  "porque", "pues", "ya que", "como", // Causales
  "si", "con tal que", "a menos que", "siempre que", // Condicionales
  "cuando", "mientras", "tan pronto como", "antes de que", // Temporales
  "para que", "a fin de que", "con el objetivo de que", // Finales
  "que", "como", "aunque", "donde", // Completivas y consecutivas

  // Inglés
  "and", "but", "or", "nor", "for", "yet", "so",
  "although", "though", "even though", "because", "since", "as",
  "if", "unless", "whether", "while", "whereas",
  "after", "before", "until", "when", "whenever", "once", "as soon as",
  "in case", "so that", "in order that", "provided that", "as long as",
  "either", "neither", "not only", "both", "whether",

  // ...otras conjunciones
  "&"
];

export const preposiciones: string[] = [
  // Español simples
  "a", "ante", "bajo", "cabe", "con", "contra", "de", "desde",
  "en", "entre", "hacia", "hasta", "para", "por", "según",
  "sin", "so", "sobre", "tras",

  // Español compuestas
  "a causa de", "a favor de", "a pesar de", "a partir de",
  "al lado de", "antes de", "cerca de", "con respecto a",
  "debajo de", "delante de", "dentro de", "después de",
  "detrás de", "encima de", "en contra de", "en lugar de",
  "en medio de", "en vez de", "frente a", "junto a", "lejos de",

  // Inglés
  "about", "above", "across", "after", "against", "along", "among", "around",
  "at", "before", "behind", "below", "beneath", "beside", "between", "beyond",
  "but", "by", "concerning", "despite", "down", "during", "except", "for",
  "from", "in", "inside", "into", "like", "near", "of", "off", "on", "onto",
  "out", "outside", "over", "past", "regarding", "since", "through", "throughout",
  "to", "toward", "under", "underneath", "until", "up", "upon", "with", "within", "without"
];

export const articulos = [
  // Español - definidos
  "el", "la", "los", "las",
  // Español - indefinidos
  "un", "una", "unos", "unas",
  // Inglés - definidos
  "the",
  // Inglés - indefinidos
  "a", "an"
];

/**
 * Escapa una consulta de Lucene, añadiendo una barra invertida antes de caracteres especiales.
 * @param query La consulta de Lucene a escapar.
 * @returns La consulta de Lucene escapada.
 */
export function escapeLuceneQuery(query: string): string {
  let escapedQuery = '';

  for (let i = 0; i < query.length; i++) {
    const c = query.charAt(i);
    if (
      c === '\\' || c === '+' || c === '-' || c === '!' || c === '(' || c === ')' ||
      c === ':' || c === '^' || c === '[' || c === ']' || c === '"' || c === '{' ||
      c === '}' || c === '~' || c === '*' || c === '?' || c === '|' || c === '&' ||
      c === '/'
    ) {
      escapedQuery += '\\';
    }
    escapedQuery += c;
  }

  return escapedQuery;
}
